import request from '@/axios'

// ====================岳辉==========================
// base-获取施工订单状态
export function getOrderProcess(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/base/getOrderProcess',
    method: 'post',
    data
  })
}
// A-在线交付-01-获取待交底客户
export function getConfideOrder(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/confide/getConfideOrder',
    method: 'post',
    data
  })
}
// A-在线交付-02-创建交底
export function saveConfide(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/confide/saveConfide',
    method: 'post',
    data
  })
}
// B-竣工-创建竣工邀请函
export function saveCompleted(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/construction/saveCompleted',
    method: 'post',
    data
  })
}
// ====================师琼==========================
// A-在线交付-03-获取客户详情
export function getConfideInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/confide/getConfideInfo',
    method: 'post',
    data
  })
}
// A-在线交付-05-获取施工排期
export function getConstructionPlan(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/construction/getConstructionPlan',
    method: 'post',
    data
  })
}
// D-客诉-01-获取客诉列表
export function getComplaintList(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/getComplaintList',
    method: 'post',
    data
  })
}
// D-客诉-02-获取客诉详情
export function getComplaintInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_inspection/sidebar/complaint/getComplaintInfo',
    method: 'post',
    data
  })
}
// A - 工程交底 - 03 - 获取排期方案
export function getSchedulingInfo(data) {
  return request({
    url: process.env.VUE_APP_DELIVERY_API + '/api_inspection/applets/v2/disclose/getSchedulingInfo',
    method: 'post',
    data
  })
}
